/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2023-01-31 14:11:01
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2026-04-17 13:57:32
 * @Description: App入口文件
 */
import { Route, Routes, Navigate } from 'react-router-dom'
import CCHeader from './components/header/header'
import CCFooter from './components/footer/footer'
import { FloatingBubble } from 'antd-mobile'
import { UpCircleOutline } from 'antd-mobile-icons'
import { useEffect, Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import routerList from '@/router/index'
import Loading from '@/components/loading/loading'
// import NoFound from '@/pages/404/noFind'
import './APP.scss'
import usePageStayTime from '@/unit/statistics'
function App() {
  usePageStayTime()
  let location = useLocation();
  const goTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }
  useEffect(() => {
    goTop();
  }, [location])
  return (
    <>
      <CCHeader />
      <Routes>
        {
          routerList.map((item, index) => {
            return <Route key={index} index path={'/:lang' + item.path} element={
              <Suspense fallback={
                <Loading />
              }>
                <item.component />
              </Suspense>
            }></Route>
          })
        }
        <Route path="/*" element={<Navigate to="/zh" replace />} />
      </Routes>
      <CCFooter />
      <FloatingBubble
        axis='xy'
        magnetic='x'
        style={{
          '--initial-position-bottom': '50px',
          '--initial-position-right': '14px',
          '--edge-distance': '24px',
          '--size': '30px',
          '--z-index': '3'
        }}
        onClick={goTop}
      >
        <UpCircleOutline fontSize={30} />
      </FloatingBubble>
    </>

  );
}

export default App;
